export default {
  getIsNavOpen: (state) => state.isNavOpen,
  getNavOption: (state) => state.navOption,
  getIsMobileDensity: (state) => state.isMobileDensity,
  getUserSitemap: function (state) {
    return state.sitemap;
  },
  getSidebarBadges: (state) => state.sidebarBadges,
  getItemModel: (state) => state.itemModel,
  getSidebarBadgeTotals: (state) => state.sidebarBadges,
  getAssignedRequests: (state) => state.assignedRequests,
  getSitemapInfo: (state) => state.sitemapInfo,
};
